import React from 'react';
import { resolveDomainApp } from '../host/resolveDomainApp';

const RootApp = () => {
  const DomainApp = resolveDomainApp(window.location.hostname);
  return <DomainApp />;
};

export default RootApp;
